import ActionMenu from "./ActionMenu";

export const bookingColumns = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Room Number",
    accessor: "number",
  },
  {
    Header: "Room Type",
    accessor: "roomType",
  },
  {
    Header: "Check In",
    accessor: "checkIn",
  },
  {
    Header: "Check Out",
    accessor: "checkOut",
  },
  {
    Header: "Paid Amount",
    accessor: "paidAmount",
  },
  {
    Header: "Due Amount",
    accessor: "dueAmount",
  },
  {
    Header: "Action",
    accessor: "action",
  },
  {
    Header: "Payment Status",
    accessor: "paymentStatus",
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: ({ row }) => <ActionMenu row={row.original} />,
    disableSortBy: true,
  },
];

export const bookingTableData = [
  {
    name: "Frank Baker",
    roomType: "Single",
    checkIn: "12/03/2024",
    checkOut: "13/03/2024",
    paidAmount: "0.00",
    dueAmount: "$230",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Phil Glover",
    roomType: "Studio",
    checkIn: "12/03/2024",
    checkOut: "21/03/2024",
    paidAmount: "0.00",
    dueAmount: "$4450",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Rya Randall",
    roomType: "Deluxe",
    checkIn: "12/03/2024",
    checkOut: "24/03/2024",
    paidAmount: "0.00",
    dueAmount: "$430",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Sally Graham",
    roomType: "Queen",
    checkIn: "12/03/2024",
    checkOut: "17/03/2024",
    paidAmount: "$1550",
    dueAmount: "0.00",
    status: "Success",
    statusColor: "text-bg-success",
  },
  {
    name: "Victor Rampling",
    roomType: "Junior Suite",
    checkIn: "12/03/2024",
    checkOut: "15/03/2024",
    paidAmount: "0.00",
    dueAmount: "$530",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Robert Anderson",
    roomType: "Cabana",
    checkIn: "03/05/2021",
    checkOut: "10/07/2021",
    paidAmount: "0.00",
    dueAmount: "$1780",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Ryan Stewart",
    roomType: "Connecting",
    checkIn: "10/07/2021",
    checkOut: "18/08/2021",
    paidAmount: "0.00",
    dueAmount: "$1230",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Joan Dyer",
    roomType: "Queen",
    checkIn: "12/03/2021",
    checkOut: "14/03/2021",
    paidAmount: "0.00",
    dueAmount: "$2230",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Liam Berry",
    roomType: "King",
    checkIn: "11/04/2021",
    checkOut: "12/04/2021",
    paidAmount: "0.00",
    dueAmount: "$400",
    status: "Pending",
    statusColor: "text-bg-warning",
  },
  {
    name: "Dean Otto",
    roomType: "Quad",
    checkIn: "11/04/2021",
    checkOut: "12/04/2021",
    paidAmount: "0.00",
    dueAmount: "$950",
    status: "Success",
    statusColor: "text-bg-success",
  },
];
